export const categories = [
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-2-line', description: '国产漫画精品，支持原创作者' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line', description: '经典日漫连载，热血与感动' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-star-line', description: '韩式画风，剧情引人入胜' },
  { slug: 'shaonian', name: '少年漫', icon: 'ri-fire-line', description: '热血战斗，青春梦想' },
  { slug: 'shaonv', name: '少女漫', icon: 'ri-heart-line', description: '浪漫爱情，细腻情感' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', description: '修仙玄幻，异世冒险' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '都市生活，职场故事' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技，星际探索' },
];

export const comics = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cover%20art%2C%20martial%20arts%20cultivation%20theme%2C%20dynamic%20action%20pose%2C%20flame%20effects%2C%20anime%20style%20illustration%2C%20warm%20golden%20tones%2C%20clean%20light%20background%2C%20professional%20comic%20cover%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成为了废人，种种打击接踵而至。就在他即将绝望的时候，一缕幽魂从他手上的戒指里浮现，一扇全新的大门在面前开启！',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第1240话 最终决战',
    rating: 9.6,
    views: 12800000,
    tags: ['玄幻', '热血', '战斗', '修炼'],
    chapters: [
      { id: 1240, title: '第1240话 最终决战', date: '2026-08-04' },
      { id: 1239, title: '第1239话 萧炎的反击', date: '2026-08-03' },
      { id: 1238, title: '第1238话 魂殿来袭', date: '2026-08-02' },
    ],
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    category: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20supernatural%20manhua%20cover%2C%20taoist%20theme%2C%20modern%20city%20background%2C%20mysterious%20atmosphere%2C%20anime%20style%2C%20cool%20color%20tones%2C%20professional%20comic%20cover&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝找上了张楚岚，张楚岚平静的校园生活被彻底颠覆。在这个异人的世界里，一场围绕着八奇技的争夺战即将展开。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第612话 天师下山',
    rating: 9.8,
    views: 15600000,
    tags: ['国漫', '都市', '异能', '悬疑'],
    chapters: [
      { id: 612, title: '第612话 天师下山', date: '2026-08-04' },
      { id: 611, title: '第611话 罗天大醮', date: '2026-08-01' },
      { id: 610, title: '第610话 八奇技之谜', date: '2026-07-29' },
    ],
  },
  {
    id: 3,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20demon%20slayer%20style%2C%20samurai%20sword%20action%2C%20traditional%20Japanese%20aesthetic%2C%20water%20breathing%20effects%2C%20anime%20art%20style%2C%20dark%20blue%20and%20red%20contrast%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。少年灶门炭治郎，一家惨遭恶鬼杀害，唯一幸存下来的妹妹祢豆子却变成了鬼。',
    status: '已完结',
    updateTime: '2025-12-01',
    latestChapter: '第205话 完结',
    rating: 9.7,
    views: 22300000,
    tags: ['日漫', '热血', '战斗', '奇幻'],
    chapters: [
      { id: 205, title: '第205话 完结', date: '2025-12-01' },
      { id: 204, title: '第204话 黎明的曙光', date: '2025-11-28' },
      { id: 203, title: '第203话 最终之战', date: '2025-11-25' },
    ],
  },
  {
    id: 4,
    title: '我独自升级',
    author: 'Chugong',
    category: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20solo%20leveling%20style%2C%20dark%20fantasy%20hunter%20theme%2C%20shadow%20army%2C%20cool%20male%20protagonist%2C%20anime%20art%2C%20purple%20dark%20atmosphere%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '10年前，世界与其他次元链接的"门"被打开，被称为"猎人"的人们觉醒。在这个弱肉强食的世界里，被称为"人类最弱兵器"的E级猎人成振宇，在一次双重地下城事件后获得了神秘的能力。',
    status: '已完结',
    updateTime: '2026-03-15',
    latestChapter: '第179话 完结',
    rating: 9.9,
    views: 35000000,
    tags: ['韩漫', '奇幻', '战斗', '升级'],
    chapters: [
      { id: 179, title: '第179话 完结', date: '2026-03-15' },
      { id: 178, title: '第178话 最终觉醒', date: '2026-03-12' },
      { id: 177, title: '第177话 君主之战', date: '2026-03-09' },
    ],
  },
  {
    id: 5,
    title: '完美世界',
    author: '辰东',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%2C%20ancient%20cultivation%20world%2C%20floating%20immortal%20realm%2C%20golden%20divine%20light%2C%20mythical%20beasts%2C%20epic%20fantasy%20art%2C%20warm%20golden%20and%20jade%20green%2C%20professional%20comic%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第892话 九天十地',
    rating: 9.5,
    views: 18900000,
    tags: ['玄幻', '修仙', '战斗', '热血'],
    chapters: [
      { id: 892, title: '第892话 九天十地', date: '2026-08-03' },
      { id: 891, title: '第891话 荒天帝', date: '2026-08-01' },
      { id: 890, title: '第890话 万族战场', date: '2026-07-30' },
    ],
  },
  {
    id: 6,
    title: '怦然心动',
    author: 'kid岁',
    category: 'shaonv',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20cover%2C%20high%20school%20love%20story%2C%20sweet%20couple%20illustration%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20warm%20tones%2C%20anime%20style%2C%20professional%20shojo%20comic%20cover&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '狄淇儿和江应怜从高中到大学的纯爱故事，从最初的误会到相互理解，从校园到社会的成长历程。青春里最美好的事情，就是恰好遇到了你。',
    status: '连载中',
    updateTime: '2026-08-02',
    latestChapter: '第345话 毕业季',
    rating: 9.3,
    views: 9800000,
    tags: ['少女漫', '校园', '恋爱', '青春'],
    chapters: [
      { id: 345, title: '第345话 毕业季', date: '2026-08-02' },
      { id: 344, title: '第344话 樱花树下的约定', date: '2026-07-30' },
      { id: 343, title: '第343话 心动的瞬间', date: '2026-07-28' },
    ],
  },
  {
    id: 7,
    title: '镇魂街',
    author: '许辰',
    category: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20manhua%20cover%2C%20guardian%20spirit%20warrior%2C%20urban%20fantasy%2C%20ancient%20Chinese%20armor%2C%20fire%20and%20shadow%20effects%2C%20anime%20style%2C%20dramatic%20lighting%2C%20professional%20comic%20cover&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '普通的应届大学毕业生夏玲，在求职之际误入罗刹街，被恶灵追杀。危急时刻，镇魂将曹焱兵出手相救。这个世界并没有看上去那么简单，每个人都有自己的守护灵。',
    status: '连载中',
    updateTime: '2026-08-01',
    latestChapter: '第456话 十殿阎罗',
    rating: 9.4,
    views: 11200000,
    tags: ['国漫', '热血', '奇幻', '战斗'],
    chapters: [
      { id: 456, title: '第456话 十殿阎罗', date: '2026-08-01' },
      { id: 455, title: '第455话 守护灵觉醒', date: '2026-07-28' },
      { id: 454, title: '第454话 罗刹街之战', date: '2026-07-25' },
    ],
  },
  {
    id: 8,
    title: '咒术回战',
    author: '芥见下下',
    category: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20jujutsu%20sorcerer%20theme%2C%20cursed%20energy%20effects%2C%20modern%20Tokyo%20setting%2C%20anime%20art%20style%2C%20red%20and%20black%20color%20scheme%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '高中生虎杖悠仁因缘际会下吞下了诅咒之王两面宿傩的手指，从而被卷入咒术师的世界。为了收集散落在各地的宿傩手指，虎杖加入了东京都立咒术高等专门学校。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第268话 最后的咒术',
    rating: 9.6,
    views: 19800000,
    tags: ['日漫', '战斗', '黑暗奇幻', '校园'],
    chapters: [
      { id: 268, title: '第268话 最后的咒术', date: '2026-08-04' },
      { id: 267, title: '第267话 宿傩之战', date: '2026-07-31' },
      { id: 266, title: '第266话 五条悟的决意', date: '2026-07-28' },
    ],
  },
  {
    id: 9,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%2C%20beauty%20makeup%20transformation%20theme%2C%20fashionable%20female%20lead%2C%20campus%20life%2C%20soft%20pastel%20colors%2C%20anime%20style%2C%20trendy%20illustration%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '因为外貌而感到自卑的女生任朱静，通过化妆技术彻底改变了自己。在新学校里成为了众人眼中的女神，但她必须小心翼翼地保守自己的真实面貌。',
    status: '已完结',
    updateTime: '2025-06-20',
    latestChapter: '第228话 完结',
    rating: 9.2,
    views: 14500000,
    tags: ['韩漫', '恋爱', '校园', '搞笑'],
    chapters: [
      { id: 228, title: '第228话 完结', date: '2025-06-20' },
      { id: 227, title: '第227话 真正的美', date: '2025-06-17' },
      { id: 226, title: '第226话 勇敢做自己', date: '2025-06-14' },
    ],
  },
  {
    id: 10,
    title: '狐妖小红娘',
    author: '小新',
    category: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manhua%20cover%2C%20fox%20spirit%20matchmaker%20theme%2C%20ancient%20Chinese%20aesthetic%2C%20beautiful%20flowing%20robes%2C%20pink%20and%20gold%20tones%2C%20anime%20style%2C%20dreamy%20atmosphere%2C%20professional%20comic%20cover&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死了，妖活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第567话 月红篇',
    rating: 9.5,
    views: 13500000,
    tags: ['国漫', '奇幻', '恋爱', '古风'],
    chapters: [
      { id: 567, title: '第567话 月红篇', date: '2026-08-03' },
      { id: 566, title: '第566话 涂山故事', date: '2026-07-31' },
      { id: 565, title: '第565话 前世今生', date: '2026-07-28' },
    ],
  },
  {
    id: 11,
    title: '一拳超人',
    author: 'ONE / 村田雄介',
    category: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20superhero%20action%20manga%20cover%2C%20bald%20hero%20in%20yellow%20costume%2C%20explosive%20action%20scene%2C%20dynamic%20composition%2C%20red%20and%20yellow%20color%20scheme%2C%20anime%20style%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '主人公埼玉原本是一名整日奔波于求职的普通人。通过拼命锻炼，他获得了最强的力量，但也变成了光头。无论面对多么强大的敌人，埼玉都能一拳解决。',
    status: '连载中',
    updateTime: '2026-07-28',
    latestChapter: '第245话 英雄协会',
    rating: 9.7,
    views: 21000000,
    tags: ['日漫', '搞笑', '战斗', '英雄'],
    chapters: [
      { id: 245, title: '第245话 英雄协会', date: '2026-07-28' },
      { id: 244, title: '第244话 S级集结', date: '2026-07-21' },
      { id: 243, title: '第243话 怪人协会', date: '2026-07-14' },
    ],
  },
  {
    id: 12,
    title: '武动乾坤',
    author: '天蚕土豆',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20ancient%20cultivation%20theme%2C%20powerful%20young%20warrior%2C%20energy%20aura%20effects%2C%20mountain%20and%20cloud%20background%2C%20golden%20and%20crimson%20tones%2C%20anime%20style%2C%20professional%20comic%20cover&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '修炼一途，乃窃阴阳，夺造化，转涅槃，握生死，掌轮回。武之极，破苍穹，动乾坤！少年林动偶然获得神秘石符，从此踏上逆天改命的修炼之路。',
    status: '已完结',
    updateTime: '2025-11-30',
    latestChapter: '第780话 完结',
    rating: 9.4,
    views: 13500000,
    tags: ['玄幻', '修炼', '热血', '战斗'],
    chapters: [
      { id: 780, title: '第780话 完结', date: '2025-11-30' },
      { id: 779, title: '第779话 武祖之威', date: '2025-11-27' },
      { id: 778, title: '第778话 乾坤动', date: '2025-11-24' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20boy%20avatar%20portrait%2C%20simple%20style%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20cartoon%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '古古漫画网真的太好用了！更新速度超快，画质清晰，下拉式阅读体验超棒。每天必刷！',
    rating: 5,
  },
  {
    id: 2,
    name: '樱花下的约定',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20portrait%2C%20simple%20style%2C%20clean%20white%20background%2C%20gentle%20smile%2C%20cartoon%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '追了三年漫画了，这里的资源最全，分类也很清晰。不管是国漫还是日漫都能找到！',
    rating: 5,
  },
  {
    id: 3,
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=cool%20anime%20boy%20avatar%20portrait%2C%20simple%20style%2C%20clean%20white%20background%2C%20sharp%20eyes%2C%20cartoon%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '页面简洁无广告干扰，加载速度也很快。漫画种类丰富，是我用过最好的漫画网站！',
    rating: 5,
  },
];

export const featuredCollections = [
  {
    id: 1,
    title: '🔥 本周热门推荐',
    description: '根据阅读量和评分精选的当周最受欢迎漫画',
    comicIds: [1, 4, 3, 8, 7, 11],
  },
  {
    id: 2,
    title: '✨ 新作上线',
    description: '最新上架的热门漫画，新鲜出炉不容错过',
    comicIds: [5, 10, 6, 2, 9, 12],
  },
  {
    id: 3,
    title: '🏆 评分最高',
    description: '站内用户评分最高的经典漫画合集',
    comicIds: [4, 2, 3, 11, 1, 8],
  },
];

export const faqData = [
  {
    question: '古古漫画网的漫画都是免费的吗？',
    answer: '是的，古古漫画网上的所有漫画均为免费阅读，无需付费即可享受完整全集内容。我们致力于为广大漫画爱好者提供优质的免费漫画阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们每日更新最新漫画章节，紧跟各大平台的连载进度。热门漫画通常在作者更新后24小时内同步上线，确保您不错过任何精彩内容。',
  },
  {
    question: '支持哪些阅读方式？',
    answer: '古古漫画网支持下拉式阅读模式，您可以在电脑、平板和手机上流畅阅读。页面自动适配各种屏幕尺寸，随时随地畅享漫画世界。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索框直接搜索漫画名称、作者名或关键词。也可以在分类页面按国漫、日漫、韩漫等类别浏览，快速找到感兴趣的漫画。',
  },
  {
    question: '可以下载漫画离线阅读吗？',
    answer: '目前古古漫画网支持在线下拉式阅读，暂不支持离线下载功能。我们推荐您使用在线收藏功能，方便随时回看喜欢的漫画。',
  },
];